import { CircleX } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { useConfigurationContext } from "../root/ConfigurationContext";

/**
 * One row per configured record type, any number of them on at once.
 *
 * Looks like a column of ToggleFilterButtons, but those are single-select on
 * one key. Where the selection is kept is the caller's business: the contact
 * list keeps it in its filters, the task list reads the same selection from
 * the store. LCCRM-86.
 */
export const RecordTypeToggleList = ({
  selected,
  onToggle,
  size = "sm",
  className,
}: {
  selected: readonly string[];
  onToggle: (value: string) => void;
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
}) => {
  const { recordTypes } = useConfigurationContext();

  return (
    <>
      {recordTypes.map((type) => {
        const isSelected = selected.includes(type.value);
        return (
          <Button
            key={type.value}
            type="button"
            variant={isSelected ? "highlight" : "ghost"}
            aria-pressed={isSelected}
            onClick={() => onToggle(type.value)}
            className={cn(
              "cursor-pointer flex flex-row items-center justify-between gap-2 px-2.5 w-full",
              className,
            )}
            size={size}
          >
            {type.label}
            {isSelected && <CircleX className="opacity-50" />}
          </Button>
        );
      })}
    </>
  );
};
